<template>
  <div>
    <img :width="width" :height="height" v-bind:src="data.Records[0].url" />
  </div>
</template>

<script>
export default {
  props: {
    height: Number,
    width: Number,
  },
  data() {
    return {
      data: {
        Page_id: 0,
        Report_id: null,
        Records: [
          {
            value: "",
            form_id: 0,
            form_type: 10,
            url:
              "https://mountain-gorilla.co.jp/wordpress/wp-content/themes/wsc8_child/img/logo_bl_yoko.jpg",
          },
        ],
      },
    };
  },
  async mounted() {
    //初期処理
    this.data.Records[0] = this.record;
    this.size = 2;
  },
  methods: {
    changeFile() {},
  },
};
</script>

<style></style>
